import PropTypes from 'prop-types';
import React from 'react';

import { Flex } from 'reflexbox';
import {
  ButtonCircle,
  Text,
} from 'rebass';
import Icon from 'react-geomicons';

import config from 'frontend/config';
import If from './If';

const ErrorText = ({ children, noIcon, ...props }) => (
  <Flex align="center" {...props}>
    <If
      condition={!noIcon}
      then={() => (
        <ButtonCircle
          mr={1}
          backgroundColor={config.colors.error}
          size={22}
          style={{
            minWidth: 22,
            minHeight: '22px',
            lineHeight: '22px',
          }}
        >
          <Icon name="close" size={12} fill={config.colors.black} />
        </ButtonCircle>
      )}
    />
    <Text bold color={config.colors.error} style={{ fontSize: 17 }}>
      {children}
    </Text>
  </Flex>
);

ErrorText.propTypes = {
  children: PropTypes.node.isRequired,
  noIcon: PropTypes.bool,
};

ErrorText.defaultProps = {
  noIcon: false,
};

export default ErrorText;
